export const BI_EVENT = 'BI_EVENT';
